module.exports = __webpack_public_path__ + "img/onboarding_people.5099c89c.svg";